import { NgModule } from "@angular/core";
import { VideoTestimonialsReferenceComponent } from "./video-testimonials-reference.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [VideoTestimonialsReferenceComponent],
  declarations: [VideoTestimonialsReferenceComponent],
})
export class VideoTestimonialsReferenceModule {}
